import { createFileRoute, Outlet } from "@tanstack/react-router"
import { Module } from "~/components/design-system/pages"
import { BreadcrumbWrapper } from "~/components/reusable/Breadcrumb"
import { InactiveVariantsWithStockWarning } from "~/components/purchaseOrder/InactiveVariantsWithStockWarning"

export const Route = createFileRoute("/_auth/insights/inventory-overview/_layout")({
  component: RouteComponent,
})

function RouteComponent() {
  return (
    <Module breadcrumb={<BreadcrumbWrapper />} actions={<InactiveVariantsWithStockWarning />}>
      <Outlet />
    </Module>
  )
}
